import { useEffect, useState } from 'react'

/**
 * 移动端断点(与 Tailwind md 一致): <768px。
 *
 * 全项目移动端视口判断的唯一来源: 需要断点字符串时从这里引用, 不要再写死 '(max-width: 767px)'。
 */
export const MOBILE_MEDIA_QUERY = '(max-width: 767px)'

/** 命令式判断当前是否为移动端视口 (SSR 安全); 适合初始 state / 一次性判断 */
export function isMobileViewport(): boolean {
  if (typeof window === 'undefined' || !window.matchMedia) return false
  return window.matchMedia(MOBILE_MEDIA_QUERY).matches
}

/** 响应式判断当前是否为移动端视口, 随窗口尺寸变化实时更新 */
export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState(() => isMobileViewport())

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return

    const query = window.matchMedia(MOBILE_MEDIA_QUERY)
    const sync = () => setIsMobile(query.matches)

    sync()
    query.addEventListener('change', sync)
    return () => query.removeEventListener('change', sync)
  }, [])

  return isMobile
}
